/*
 * GB Lookbook countdown.
 *
 * sections/gb-lb-countdown.liquid already renders the correct digits server
 * side, so this script only keeps them moving. It never writes the heading or
 * the unit labels - those are translations, and Liquid owns them.
 *
 * `data-deadline` is a full ISO 8601 stamp with an explicit offset, so
 * Date.parse agrees with Liquid about which moment is meant no matter what
 * timezone the visitor is in.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-gb-lb-countdown]';
  var timers = new WeakMap();

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function paint(root, remaining) {
    var units = {
      days: Math.floor(remaining / 86400),
      hours: Math.floor((remaining % 86400) / 3600),
      minutes: Math.floor((remaining % 3600) / 60),
      seconds: Math.floor(remaining % 60),
    };

    Object.keys(units).forEach(function (unit) {
      var el = root.querySelector('[data-gb-lb-countdown-unit="' + unit + '"]');
      if (!el) return;
      var next = pad(units[unit]);
      // Only touch the DOM when the digits actually change, so a screen reader
      // is not handed four updates a second.
      if (el.textContent !== next) el.textContent = next;
    });
  }

  function expire(root) {
    var behaviour = root.dataset.expiredBehaviour;
    var units = root.querySelector('[data-gb-lb-countdown-units]');
    var message = root.querySelector('[data-gb-lb-countdown-expired]');

    if (behaviour === 'hide') {
      root.hidden = true;
      return;
    }

    if (behaviour === 'message') {
      if (units) units.hidden = true;
      // With no message authored there is nothing left to show, so the band
      // would sit there empty - hide it rather than leave a blank slab.
      if (message) message.hidden = false;
      else root.hidden = true;
    }
    // 'zeros' needs nothing: paint() has already written 00 across the board.
  }

  function stop(root) {
    var id = timers.get(root);
    if (id) {
      clearInterval(id);
      timers.delete(root);
    }
  }

  function start(root) {
    stop(root);

    var deadline = Date.parse(root.dataset.deadline);
    if (isNaN(deadline)) return;

    var done = false;

    var tick = function () {
      var remaining = Math.floor((deadline - Date.now()) / 1000);

      if (remaining > 0) {
        paint(root, remaining);
        return;
      }

      done = true;
      paint(root, 0);
      stop(root);
      expire(root);
    };

    // Run once up front: a deadline that has already passed must never start an
    // interval just to clear it a second later.
    tick();
    if (!done) timers.set(root, setInterval(tick, 1000));
  }

  function init(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // The theme editor swaps section markup in and out without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll(SELECTOR).forEach(stop);
  });
})();
